export const CUBE_ID = 'facts_slides';
export const REPORT_ID = 'aquarium-production';
export const REPORT_APE_ID = 'aquarium-production-ape';